//Principais
import { Location } from '@angular/common';
import {
  Component,
  ElementRef,
  inject,
  OnInit,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, ParamMap, RouterLink } from '@angular/router';
import { NgSelectConfig } from '@ng-select/ng-select';
import {
  debounceTime,
  distinctUntilChanged,
  lastValueFrom,
  takeUntil,
  Subject,
} from 'rxjs';
//Models
import { ArquivoAzure } from 'src/app/shared/models/arquivo/ArquivoAzure';
import { ChamadoDeletar } from 'src/app/shared/models/chamados/chamadoDeletar';
import { ListarChamados } from 'src/app/shared/models/chamados/listar-chamados';
import { Diretoria } from 'src/app/shared/models/diretoria/Diretoria';
import { Escola } from 'src/app/shared/models/escola/Escola';

//Services
import { NgbPagination } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from 'components/base/base.component';
import { saveAs } from 'file-saver';
import { HistoricoChamado } from 'src/app/shared/models/chamados/historico';
import { FiltroPadrao } from 'src/app/shared/models/filtro-padrao/filtroPadrao';
import { CadAtendimento } from 'src/app/shared/models/psicologo/CadAtendimento';
import { AtribuicaoLoginSed } from 'src/app/shared/models/sed/UserLogin';
import { AgendamentoService } from 'src/app/shared/services/agendamento.service';
import { ArquivoService } from 'src/app/shared/services/arquivo.service';
import { AtendimentoService } from 'src/app/shared/services/atendimento.service';
import { ChamadoService } from 'src/app/shared/services/chamado.service';
import { ConcluirService } from 'src/app/shared/services/concluir.service';
import { ConvivaErrorHandlingService } from 'src/app/shared/services/convivaErrorHandlingService';
import { EncaminhamentoService } from 'src/app/shared/services/encaminhamento.service';
import { FiltroService } from 'src/app/shared/services/filtro.service';
import { HistoricoChamadoService } from 'src/app/shared/services/historicoChamado.service';
import { angularCommonImports } from 'src/app/shared/ui/angular-common';
import { convivaCommonImports } from 'src/app/shared/ui/conviva-common';
import { libsCommonImports } from 'src/app/shared/ui/libs-common';
import { ChamadoFiltro } from './chamado.unificado.component.filtro';

@Component({
  templateUrl: './chamado.unificado.component.html',
  styleUrls: ['./chamado.unificado.component.scss'],
  standalone: true,
  imports: [
    angularCommonImports,
    convivaCommonImports,
    libsCommonImports,
    NgbPagination,
    RouterLink,
  ],
})
export class ChamadoUnificadoComponent extends BaseComponent implements OnInit {
  private filtroService = inject(FiltroService);
  private ConvivaErrors = inject(ConvivaErrorHandlingService);
  public formCadastrar!: FormGroup;
  protected destroy$ = new Subject<void>();

  public listarChamados: ListarChamados[] = [];
  public listarChamadosAll: ListarChamados[] = [];
  private chamadoService = inject(ChamadoService);
  public filtro!: ChamadoFiltro;
  public page = 1;
  public filtroAplicado = false;

  //NG
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.filtro = new ChamadoFiltro(this.filtroService.filtro());

    this.formCadastrar = new FormGroup({
      //Default - Vão para API
      codigoDiretoria: new FormControl(this.filtro.codigoDiretoria ?? null),
      codigoEscola: new FormControl(this.filtro.codigoEscola ?? null),
      codigoGravidade: new FormControl(this.filtro.codigoGravidade ?? null),

      //Filtros locais - NÃO vão para API
      nomeAluno: new FormControl(this.filtro.nomeAluno ?? null),
      raAluno: new FormControl(this.filtro.raAluno ?? null),
      codigoChamado: new FormControl(this.filtro.codigoChamado ?? null),
      codigoStatus: new FormControl(this.filtro.codigoStatus ?? null),
      cpfEquipeEscolar: new FormControl(this.filtro.cpfEquipeEscolar ?? null),
    });

    this.formCadastrar.patchValue({
      codigoDiretoria: this.filtro.codigoDiretoria ?? null,
      codigoEscola: this.filtro.codigoEscola ?? null,
      codigoGravidade: this.filtro.codigoGravidade ?? null,
      nomeAluno: this.filtro.nomeAluno ?? null,
      raAluno: this.filtro.raAluno ?? null,
      codigoChamado: this.filtro.codigoChamado ?? null,
      codigoStatus: this.filtro.codigoStatus ?? null,
      cpfEquipeEscolar: this.filtro.cpfEquipeEscolar ?? null,
    });

    this.formCadastrar.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        takeUntil(this.destroy$),
      )
      .subscribe((values) => {
        this.filtro = new ChamadoFiltro({
          ...this.filtro,
          ...values,
          pagina: 1,
        });
        this.filtroService.atualizaFiltro(this.filtro);
        this.FiltraChamadosAtuais();
      });
  }

  //ON
  public async OnPesquisar() {
    this.Voltar();
    this.page = 1; // Resetar para a primeira página
    this.spinnerService.show();

    let result = await this.getChamadosEnvolvidos();
    this.listarChamados = result?.data;
    this.listarChamadosAll = result?.data;

    this.spinnerService.hide();
  }

  public async onPageChange() {
    // A página já é atualizada automaticamente pelo [(page)]
    // Não precisa buscar mais dados da API, pois já temos todos os dados
    // A paginação é feita no front-end
  }

  public getCorStatus(status: number): string {
    switch (status) {
      case 0:
        return 'cinza';
      case 1:
        return 'cinza';
      case 2:
        return 'azul';
      case 3:
        return 'laranja';
      case 4:
        return 'verde';
      case 5:
        return 'verde';
      case 6:
        return 'vermelho';
      default:
        return '';
    }
  }

  public FiltraChamadosAtuais() {
    this.page = 1; // Resetar para a primeira página ao filtrar

    const codigoGravidade = this.filtro.codigoGravidade;
    const codigoStatus = this.filtro.codigoStatus;
    const nomeAluno = this.filtro.nomeAluno?.toLowerCase().trim();
    const raAluno = this.filtro.raAluno;
    const codigoChamado = this.filtro.codigoChamado?.toString().trim();
    const cpfEquipeEscolar = this.filtro.cpfEquipeEscolar?.toLowerCase().trim();

    // Verifica se algum filtro foi aplicado
    this.filtroAplicado = !!(
      codigoGravidade ||
      codigoStatus ||
      nomeAluno ||
      raAluno ||
      codigoChamado ||
      cpfEquipeEscolar
    );

    this.listarChamados = this.listarChamadosAll.filter((item) => {
      // Filtros da API (gravidade)
      if (
        codigoGravidade != undefined &&
        item.codigoGravidade != codigoGravidade
      ) {
        return false;
      }

      // Filtro de status
      if (
        codigoStatus != undefined &&
        item.aluno?.statusEnvolvido != codigoStatus
      ) {
        return false;
      }

      // Filtro de nome do aluno
      if (
        nomeAluno &&
        !item.aluno?.nomeAluno?.toLowerCase().includes(nomeAluno)
      ) {
        return false;
      }

      // Filtro de RA
      if (
        raAluno &&
        !item.aluno?.ra?.toLowerCase().includes(raAluno.toString())
      ) {
        return false;
      }

      // Filtro de código do chamado
      if (
        codigoChamado &&
        !item.codigoChamado?.toString().includes(codigoChamado)
      ) {
        return false;
      }

      // Filtro de CPF da equipe escolar
      if (
        cpfEquipeEscolar &&
        !item.equipeEscolar?.cpf?.toLowerCase().includes(cpfEquipeEscolar)
      ) {
        return false;
      }

      return true;
    });
  }

  public visualizarChamado(codigoChamado: number) {
    this.router.navigate(['/detalhe', codigoChamado]);
  }

  public temFiltrosAtivos(): boolean {
    return !!(
      this.filtro.codigoGravidade ||
      this.filtro.codigoStatus ||
      this.filtro.nomeAluno ||
      this.filtro.raAluno ||
      this.filtro.codigoChamado ||
      this.filtro.cpfEquipeEscolar
    );
  }

  async listeningFiltroEmitter(eventFilter: FiltroPadrao) {
    this.filtro = new ChamadoFiltro(eventFilter);
    this.OnPesquisar();
  }

  private async getChamadosEnvolvidos() {
    const formValues = this.formCadastrar.value;
    const defined: any = {};
    Object.keys(formValues).forEach((k) => {
      const v = formValues[k];
      if (v !== null && v !== undefined && v !== '' && v !== 0) defined[k] = v;
    });
    this.filtro = new ChamadoFiltro({ ...this.filtro, ...defined });

    const parametros = this.filtro.toApiParams();

    const result = await lastValueFrom(
      this.chamadoService.getChamadosEnvolvidos(parametros),
    ).catch((err) => {
      return this.ConvivaErrors.handleResultError(err);
    });

    if (!result.isSucess) {
      this.toastr.error(result.message, result.title);
      this.spinnerService.hide();
      return;
    }
    console.log('getChamadosEnvolvidos - result:', result);
    return result;
  }

  public Voltar() {
    const menu = document
      .getElementsByClassName('sidebar-chamado')
      .item(0) as HTMLElement;
    if (menu != null) menu.className = 'time-line mx-w-900';
  }
}
